import type { SVGProps } from "react";
const SvgNumber07 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    fillRule="evenodd"
    stroke="black"
    strokeWidth={0.501}
    strokeLinejoin="bevel"
    strokeMiterlimit={10}
    fontFamily="Times New Roman"
    fontSize={16}
    style={{
      fontVariantLigatures: "none",
    }}
    xmlnsXlink="http://www.w3.org/1999/xlink"
    xmlns="http://www.w3.org/2000/svg"
    overflow="visible"
    width="39.607pt"
    height="74.38pt"
    viewBox="139.731 -728.885 39.607 74.38"
    {...props}
  >
    <defs />
    <g id="Board Elements" transform="scale(1 -1)">
      <g
        id="Group"
        fillRule="nonzero"
        strokeLinejoin="round"
        strokeLinecap="round"
        stroke="none"
        strokeWidth={0.416}
      >
        <g id="Group_1">
          <g id="Group_2">
            <g id="Group_3" fill="#262626">
              <g id="Group_4">
                <path
                  d="M 147.354,654.518 C 146.974,654.468 146.703,654.561 146.543,654.798 C 146.382,655.035 146.34,655.352 146.417,655.75 L 160.765,709.746 C 160.904,710.152 160.784,710.33 160.403,710.279 L 152.599,709.247 C 152.346,709.213 152.176,709.029 152.091,708.695 L 152.139,705.409 C 152.118,705.084 152.011,704.795 151.818,704.544 C 151.625,704.292 151.37,704.146 151.053,704.104 L 140.87,702.756 C 140.553,702.714 140.284,702.792 140.065,702.989 C 139.845,703.185 139.746,703.447 139.767,703.772 L 139.731,720.133 C 139.753,720.459 139.86,720.747 140.052,720.999 C 140.245,721.25 140.5,721.397 140.817,721.439 L 175.84,726.072 C 176.157,726.114 176.441,726.039 176.693,725.846 C 176.944,725.654 177.059,725.394 177.038,725.069 L 177.16,713.174 L 176.956,711.791 L 162.36,657.472 C 162.254,656.812 161.884,656.441 161.249,656.357 L 147.354,654.518 Z"
                  markerStart="none"
                  markerEnd="none"
                />
              </g>
            </g>
            <g id="Group_5" fill="#f7e5c5">
              <g id="Group_6">
                <path
                  d="M 149.532,657.32 C 149.152,657.27 148.881,657.363 148.721,657.6 C 148.56,657.837 148.518,658.154 148.595,658.552 L 162.943,712.548 C 163.082,712.954 162.962,713.132 162.581,713.081 L 154.777,712.049 C 154.524,712.015 154.354,711.831 154.269,711.497 L 154.317,708.211 C 154.296,707.886 154.189,707.597 153.996,707.346 C 153.803,707.094 153.548,706.948 153.231,706.906 L 143.048,705.558 C 142.731,705.516 142.462,705.594 142.243,705.791 C 142.023,705.987 141.924,706.249 141.945,706.574 L 141.909,722.935 C 141.931,723.261 142.038,723.549 142.23,723.801 C 142.423,724.052 142.678,724.199 142.995,724.241 L 178.018,728.874 C 178.335,728.916 178.619,728.841 178.871,728.648 C 179.122,728.456 179.237,728.196 179.216,727.871 L 179.338,715.976 L 179.134,714.593 L 164.538,660.274 C 164.432,659.614 164.062,659.243 163.427,659.159 L 149.532,657.32 Z"
                  markerStart="none"
                  markerEnd="none"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
export default SvgNumber07;
